/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateMarketplaceSettingsRequestBody,
  UpdateMarketplaceSettingsRequestBody$Outbound,
  UpdateMarketplaceSettingsRequestBody$outboundSchema,
} from "../components/updatemarketplacesettingsrequestbody.js";

export type UpdateMarketplaceSettingsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateMarketplaceSettingsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateMarketplaceSettingsRequestBody: UpdateMarketplaceSettingsRequestBody;
};

/** @internal */
export type UpdateMarketplaceSettingsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateMarketplaceSettingsSecurity$outboundSchema: z.ZodMiniType<
  UpdateMarketplaceSettingsSecurity$Outbound,
  UpdateMarketplaceSettingsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateMarketplaceSettingsSecurityToJSON(
  updateMarketplaceSettingsSecurity: UpdateMarketplaceSettingsSecurity,
): string {
  return JSON.stringify(
    UpdateMarketplaceSettingsSecurity$outboundSchema.parse(
      updateMarketplaceSettingsSecurity,
    ),
  );
}

/** @internal */
export type UpdateMarketplaceSettingsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateMarketplaceSettingsRequestBody:
    UpdateMarketplaceSettingsRequestBody$Outbound;
};

/** @internal */
export const UpdateMarketplaceSettingsRequest$outboundSchema: z.ZodMiniType<
  UpdateMarketplaceSettingsRequest$Outbound,
  UpdateMarketplaceSettingsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateMarketplaceSettingsRequestBody:
      UpdateMarketplaceSettingsRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateMarketplaceSettingsRequestBody:
        "UpdateMarketplaceSettingsRequestBody",
    });
  }),
);

export function updateMarketplaceSettingsRequestToJSON(
  updateMarketplaceSettingsRequest: UpdateMarketplaceSettingsRequest,
): string {
  return JSON.stringify(
    UpdateMarketplaceSettingsRequest$outboundSchema.parse(
      updateMarketplaceSettingsRequest,
    ),
  );
}
